import type { SVGMotionProps } from 'motion/react';
import clsx from 'clsx';
import { motion } from 'motion/react';

export function HamburgerButton({
  onToggle,
  open,
  size = 24
}: {
  onToggle: () => void;
  open: boolean;
  size?: number;
}) {
  const strokeColor = open ? 'stroke-white' : 'stroke-gray-800';

  const lineProps: SVGMotionProps<unknown> = {
    animate: open ? 'opened' : 'closed',
    className: clsx(strokeColor),
    initial: 'closed',
    strokeWidth: 2,
    transition: { type: 'spring', stiffness: 300, damping: 20, mass: 1 },
    vectorEffect: 'non-scaling-stroke'
  };

  return (
    <button className="z-50 block focus:outline-hidden" onClick={onToggle} type="button">
      <motion.svg viewBox={`0 0 ${size} ${size}`} width={size} height={size}>
        <motion.path
          variants={{
            closed: {
              d: `M${size * 0.1} ${size * 0.25} L${size * 0.6} ${size * 0.25}`
            },
            opened: {
              d: `M${size * 0.2} ${size * 0.2} L${size * 0.5} ${size * 0.5}`
            }
          }}
          style={{ originX: '0%', originY: '50%' }}
          {...lineProps}
        />
        <motion.path
          variants={{
            closed: {
              rotate: 0
            },
            opened: {
              rotate: -45
            }
          }}
          d={`M${size * 0.1} ${size * 0.5} L${size * 0.9} ${size * 0.5}`}
          {...lineProps}
        />
        <motion.path
          variants={{
            closed: {
              d: `M${size * 0.1} ${size * 0.75} L${size * 0.75} ${size * 0.75}`
            },
            opened: {
              d: `M${size * 0.8} ${size * 0.8} L${size * 0.5} ${size * 0.5}`
            }
          }}
          style={{ originX: '100%', originY: '0%' }}
          {...lineProps}
        />
      </motion.svg>
    </button>
  );
}
